export default defineNuxtRouteMiddleware((to) => {
  useNuxtApp().hook('app:rendered', (ctx) => {
    if (ctx.ssrContext && ctx.ssrContext.payload) {
      ctx.ssrContext.payload.path = to.path;
    }
  });
});
